import api from './api';
import { ChatHistoryResponse } from '../models/chat';
import { BaseResponse } from '../models/responseModel';

export const getChatHistory = async (): Promise<ChatHistoryResponse> => {
    try {
        const response = await api.get('/api/Chat/GetChatHistory');

        return response.data;
    } catch (error) {
        console.error('Chat history fetch error:', error);
        throw error;
    }
};

export const deleteChat = async (guid: string): Promise<BaseResponse> => {
    try {
        const response = await api.post('/api/Chat/DeleteChat', {
            GUID: guid
        });

        return response.data;
    } catch (error) {
        console.error('Chat delete error:', error);
        throw error;
    }
};
